// extracted by mini-css-extract-plugin
export default {"jobfilter":"jobfilter__VN-1S"};